import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import type { DatePickerInputProps, DatePickerType } from '@mantine/dates';
import { DatePickerInput } from '@mantine/dates';
import { forwardRef } from 'react';

import styles from './DatePicker.module.css';

export const LBDatePicker = forwardRef<
  React.ElementRef<typeof DatePickerInput>,
  DatePickerInputProps<DatePickerType>
>((props, ref) => (
  <DatePickerInput
    classNames={styles}
    dropdownType='modal'
    modalProps={{ centered: true, radius: 8 }}
    rightSection={<CalendarDaysIcon height={18} width={18} />}
    valueFormat='DD.MM.YYYY'
    {...props}
    ref={ref}
  />
));
